import { css, styled } from 'styled-components';
import type { StyledResizableHandlerProps } from './types';

export const StyledResizableWrapper = styled.div<{ $width?: number; $height?: number }>`
    position: relative;

    ${({ $width }) =>
        $width &&
        css`
            width: ${$width}px;
        `}

    ${({ $height }) =>
        $height &&
        css`
            height: ${$height}px;
        `}
`;

export const StyledResizableHandler = styled.div<StyledResizableHandlerProps>`
    position: absolute;
    z-index: 10;
    touch-action: none;
    background-color: ${props => props.theme.root.colors.background['startBackground']};
    transition: background-color 0.2s ease;

    // Горизонтальное позиционирование (лево/право)
    ${({ $direction }) =>
        $direction === 'horizontal-left-right' &&
        css`
            top: 0;
            right: 0;
            width: 5px;
            height: 100%;
            cursor: col-resize;
        `}
    ${({ $direction }) =>
        $direction === 'horizontal-right-left' &&
        css`
            top: 0;
            left: 0;
            width: 5px;
            height: 100%;
            cursor: col-resize;
        `}

    // Вертикальное позиционирование (верх/низ)
    ${({ $direction }) =>
        $direction === 'vertical-top-bottom' &&
        css`
            left: 0;
            bottom: 0;
            width: 100%;
            height: 5px;
            cursor: row-resize;
        `}

    ${({ $direction }) =>
        $direction === 'vertical-bottom-top' &&
        css`
            left: 0;
            top: 0;
            width: 100%;
            height: 5px;
            cursor: row-resize;
        `}

    &:hover {
        background-color: ${props => props.theme.root.colors.primary.hover};
    }

    ${({ $isActive }) =>
        $isActive &&
        css`
            background-color: ${props => props.theme.root.colors.primary.default};
        `}

    &:focus {
        outline-offset: -2px;
        outline: 2px solid ${props => props.theme.root.colors.primary.default};
        background-color: ${props => props.theme.root.colors.primary.default};
    }
`;
